import "./style.css";
import React from "react";
import { BiSearchAlt } from "react-icons/bi";

export default function Pesquisar(props) {
  const handleInput = (e) => {
    if (props.apenasNumeros) {
      e.target.value = e.target.value.replace(/[^0-9]/g, "");
    }
    if (props.onInput) {
      props.onInput(e);
    }
  };
  return (
    <div className="form" style={{ width: props.width }}>
      <BiSearchAlt className="bife"></BiSearchAlt>
      <input
        className="input"
        placeholder={props.placeholder}
        required=""
        type="text"
        name={props.name}
        onInput={handleInput}
        pattern={props.pattern}
        inputMode={props.apenasNumeros ? "numeric" : props.inputMode}
        maxLength={props.maxLength}
        onChange={props.event}
        style={{
          color: props.color,
        }}
      />
      <span htmlFor={props.span} style={{ color: props.spanColor }} className="input-border">
        {props.span}
      </span>
    </div>
  );
}
